import { render, staticRenderFns } from "./Alertas.vue?vue&type=template&id=58abc32d&"
import script from "./Alertas.vue?vue&type=script&lang=js&"
export * from "./Alertas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports